module.exports = __webpack_public_path__ + "static/media/ss_2_jp.8ef09337.jpg";